var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: {
        form: _vm.form,
        rules: _vm.rules,
        "label-width": "120px",
        width: "800px",
      },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "素材名称", prop: "materialName" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.materialName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "materialName", $$v)
                  },
                  expression: "form.materialName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c("BjFormItemCode", {
            attrs: { label: "素材编码", prop: "code" },
            model: {
              value: _vm.form.code,
              callback: function ($$v) {
                _vm.$set(_vm.form, "code", $$v)
              },
              expression: "form.code",
            },
          }),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品描述", prop: "detailHtml" } },
            [
              _c("BjInput", {
                attrs: {
                  type: "textarea",
                  "show-word-limit": "",
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                  resize: "none",
                  size: "medium",
                },
                model: {
                  value: _vm.form.detailHtml,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "detailHtml", $$v)
                  },
                  expression: "form.detailHtml",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.remarkText"), prop: "remark" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "主图", prop: "mainImage" } },
            [
              _c(
                "BjUpload",
                {
                  ref: "uploadMain",
                  staticClass: "avatar-uploader",
                  attrs: {
                    "show-file-list": "",
                    "list-type": "picture-card",
                    limit: 10,
                    "image-size": 5 * 1024,
                    "video-size": 300 * 1024,
                    accept: "image/png,image/jpeg,video/*",
                    multiple: "",
                    "limit-hide": "",
                  },
                  on: {
                    afterUpload: _vm.afterUploadMain,
                    handleFileListChange: _vm.handleFileListChangeMain,
                  },
                },
                [
                  _c("template", { slot: "default" }, [
                    _c("i", {
                      staticClass: "el-icon-plus avatar-uploader-icon",
                    }),
                  ]),
                  _c("template", { slot: "tip" }, [
                    _vm._v(
                      " 视频：最大支持1段视频，支持上传时长、格式根据各平台写定，大小不超过300M"
                    ),
                    _c("br"),
                    _vm._v(
                      " 图片：可拖拽图片调整顺序，至少上传一张，支持上传文件格式、尺寸根据各平台与定，大小不超过5M"
                    ),
                    _c("br"),
                    _vm._v(" 最多上传10份（图片+视频） "),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "详情图", prop: "detailImage" } },
            [
              _c(
                "BjUpload",
                {
                  ref: "uploadDetail",
                  staticClass: "avatar-uploader",
                  attrs: {
                    limit: 20,
                    "limit-size": 5 * 1024,
                    multiple: "",
                    "show-file-list": "",
                    "list-type": "picture-card",
                    accept: "image/png,image/jpeg",
                    "limit-hide": "",
                  },
                  on: {
                    afterUpload: _vm.afterUploadDetail,
                    handleFileListChange: _vm.handleFileListChangeDetail,
                  },
                },
                [
                  _c("template", { slot: "default" }, [
                    _c("i", {
                      staticClass: "el-icon-plus avatar-uploader-icon",
                    }),
                  ]),
                  _c("template", { slot: "tip" }, [
                    _vm._v(
                      " 可拖拽图片调整顺序,支持上传文件格式、尺寸根据各平台与定，大小不超过5M "
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }